import React, { useContext } from 'react';
import AnimeRouters from './components/AnimeRouters';
import { BrowserRouter as Router } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CursorContext } from './context/CursorContext';
import Header from './components/Header';
import { useTheme } from './context/ThemeContext';

const App = () => {
  const { cursorVariants, cursorBG } = useContext(CursorContext);
  const { darkMode } = useTheme();

  return (
    <div
      style={{
        background: darkMode
          ? 'linear-gradient(to top right, #1e1b4b, #020617, #000000)'
          : '#ffffff',
        transition: 'all 0.3s ease',
      }}
      className="min-h-screen"
    >
      <Router>
        <Header />
        <AnimeRouters />
      </Router>
      <motion.div
        variants={cursorVariants}
        animate={cursorBG}
        className='w-[40px] h-[32px] bg-primary fixed top-0 left-0 pointer-events-none z-50 rounded-full'>
      </motion.div>
    </div>
  );
};

export default App;